import React from 'react'

import flattenDeep from 'lodash/flattenDeep'
import {isElement, isFragment} from 'react-is'

export const mapChildrenWithFragments = <P, T = React.ReactElement<P>>(
  children: React.ReactNode,
  iterator: (child: React.ReactElement<P>, index: number) => T = child => child as T
) =>
  flattenDeep(
    React.Children.map(children, child => {
      if (isFragment(child)) {
        return React.Children.toArray(
          (child as React.ReactElement<React.PropsWithChildren>).props.children
        )
      }
      return child
    })
  )
    .filter(child => child)
    .map((child, index) =>
      isElement(child) ? iterator(child as React.ReactElement<P>, index) : child
    )

export const countChildrenWithFragments = (children: React.ReactNode) =>
  mapChildrenWithFragments(children, child => child).length
